import { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@nextui-org/react';
import { FaCircleInfo } from 'react-icons/fa6';
import Icon from '../base/Icon';
import MarkdownWrapper from '../base/MarkdownWrapper';
import { GENERIC_APP } from '../../config/generic';
import { SOS_APP } from '../../config/sos';

export default function InfoButton() {
  const [activeModal, setActiveModal] = useState(null);
  const [markdownAbout, setMarkdownAbout] = useState('');
  const aboutUrl =
    process.env.REACT_APP_DEPLOYMENT_TYPE === 'GENERIC'
      ? process.env.PUBLIC_URL + GENERIC_APP.about
      : process.env.PUBLIC_URL + SOS_APP.about;

  useEffect(() => {
    fetch(aboutUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load about page: ${res.status}`);
        }
        return res.text();
      })
      .then(setMarkdownAbout)
      .catch((error) => {
        console.warn('Failed to load about page:', error);
        setMarkdownAbout('About information is currently unavailable.');
      });
  }, [aboutUrl]);

  const [markdownDpp, setMarkdownDpp] = useState('');
  const dppUrl =
    process.env.REACT_APP_DEPLOYMENT_TYPE === 'GENERIC'
      ? process.env.PUBLIC_URL + GENERIC_APP.dpp
      : process.env.PUBLIC_URL + SOS_APP.dpp;

  useEffect(() => {
    fetch(dppUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load dpp page: ${res.status}`);
        }
        return res.text();
      })
      .then(setMarkdownDpp)
      .catch((error) => {
        console.warn('Failed to load dpp page:', error);
        setMarkdownDpp('DPP information is currently unavailable.');
      });
  }, [dppUrl]);

  const [markdownTos, setMarkdownTos] = useState('');
  const tosUrl =
    process.env.REACT_APP_DEPLOYMENT_TYPE === 'GENERIC'
      ? process.env.PUBLIC_URL + GENERIC_APP.tos
      : process.env.PUBLIC_URL + SOS_APP.tos;

  useEffect(() => {
    fetch(tosUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load tos page: ${res.status}`);
        }
        return res.text();
      })
      .then(setMarkdownTos)
      .catch((error) => {
        console.warn('Failed to load tos page:', error);
        setMarkdownTos('ToS information is currently unavailable.');
      });
  }, [tosUrl]);

  // @ts-ignore
  const handleSelectionChange = (keys) => {
    const selected = Array.from(keys)[0];
    // @ts-ignore
    setActiveModal(selected);
  };

  const closeModal = () => setActiveModal(null);

  return (
    <>
      {/* Dropdown */}
      <Dropdown>
        <DropdownTrigger>
          <Button
            variant="flat"
            endContent={<Icon icon={FaCircleInfo} />}
            className="min-w-0 about-btn"
          ></Button>
        </DropdownTrigger>

        <DropdownMenu
          aria-label="Information Menu"
          selectionMode="single"
          onSelectionChange={handleSelectionChange}
        >
          <DropdownItem key="about">About</DropdownItem>
          <DropdownItem key="dpp">Data Protection Policy</DropdownItem>
          <DropdownItem key="tos">Terms of Use</DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {/* About Modal */}
      <Modal
        isOpen={activeModal === 'about'}
        onOpenChange={closeModal}
        size="3xl"
        backdrop="blur"
        scrollBehavior="inside"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader></ModalHeader>
              <ModalBody>
                <MarkdownWrapper>{markdownAbout}</MarkdownWrapper>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* Data Protection Policy Modal */}
      <Modal
        isOpen={activeModal === 'dpp'}
        onOpenChange={closeModal}
        size="3xl"
        backdrop="blur"
        scrollBehavior="inside"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader></ModalHeader>
              <ModalBody>
                <MarkdownWrapper>{markdownDpp}</MarkdownWrapper>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* Terms of Use Modal */}
      <Modal
        isOpen={activeModal === 'tos'}
        onOpenChange={closeModal}
        size="3xl"
        backdrop="blur"
        scrollBehavior="inside"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader></ModalHeader>
              <ModalBody>
                <MarkdownWrapper>{markdownTos}</MarkdownWrapper>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
